import { Component } from '@angular/core';
import { RegisterService } from './register.service';
import { Customer } from './customer.model';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent {

   ngAfterViewInit() {
    // This executes right after the HTML hits the screen
    setTimeout(() => {
      // Fake a window resize event to force the browser to snap the header and banner together
      window.dispatchEvent(new Event('resize'));
    }, 50); // A 50ms delay is invisible to the user but enough for the browser
  }

  newCustomer: Customer = {
    CustomerName: '',
    EmailId: '',
    Contact: ''
  };

  constructor(private registerService: RegisterService) {}

  onSubmit(){
    this.registerService.CreateCustomer(this.newCustomer).subscribe({
      next:(response) => {
        console.log('Customer added:', response);

      },
      error: (err) => {
        console.error('Error:', err);
      }
    });
  }
}
